import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=71774519"
import script from "./Totals.vue?vue&type=script&lang=ts"
export * from "./Totals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71774519')) {
      api.createRecord('71774519', component.options)
    } else {
      api.reload('71774519', component.options)
    }
    module.hot.accept("./Totals.vue?vue&type=template&id=71774519", function () {
      api.rerender('71774519', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/Totals.vue"
export default component.exports